var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.saveEmailConfig()
        },
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.driver"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_driver.$error,
                options: _vm.mailDrivers,
                "allow-empty": false,
                searchable: true,
                "show-labels": false,
              },
              on: { input: _vm.onChangeDriver },
              model: {
                value: _vm.mailConfigData.mail_driver,
                callback: function ($$v) {
                  _vm.$set(_vm.mailConfigData, "mail_driver", $$v)
                },
                expression: "mailConfigData.mail_driver",
              },
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_driver.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_driver.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.mailgun_domain"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_mailgun_domain.$error,
                type: "text",
                name: "mailgun_domain",
              },
              on: {
                input: function ($event) {
                  return _vm.$v.mailConfigData.mail_mailgun_domain.$touch()
                },
              },
              model: {
                value: _vm.mailConfigData.mail_mailgun_domain,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_mailgun_domain",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_mailgun_domain",
              },
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_mailgun_domain.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_mailgun_domain.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.mailgun_secret"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_mailgun_secret.$error,
                type: "password",
                name: "mailgun_secret",
                "show-password": "",
              },
              on: {
                input: function ($event) {
                  return _vm.$v.mailConfigData.mail_mailgun_secret.$touch()
                },
              },
              model: {
                value: _vm.mailConfigData.mail_mailgun_secret,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_mailgun_secret",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_mailgun_secret",
              },
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_mailgun_secret.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_mailgun_secret.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.mailgun_endpoint"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_mailgun_endpoint.$error,
                type: "text",
                name: "mailgun_endpoint",
              },
              on: {
                input: function ($event) {
                  return _vm.$v.mailConfigData.mail_mailgun_endpoint.$touch()
                },
              },
              model: {
                value: _vm.mailConfigData.mail_mailgun_endpoint,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_mailgun_endpoint",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_mailgun_endpoint",
              },
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_mailgun_endpoint.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_mailgun_endpoint.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.mailConfigData.mail_mailgun_endpoint.numeric
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.numbers_only")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.from_mail"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.from_mail.$error,
                type: "text",
                name: "from_mail",
              },
              on: {
                input: function ($event) {
                  return _vm.$v.mailConfigData.from_mail.$touch()
                },
              },
              model: {
                value: _vm.mailConfigData.from_mail,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "from_mail",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.from_mail",
              },
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.from_mail.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.from_mail.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.mailConfigData.from_mail.email
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.email_incorrect")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.from_name"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.from_name.$error,
                type: "text",
                name: "from_name",
              },
              on: {
                input: function ($event) {
                  return _vm.$v.mailConfigData.from_name.$touch()
                },
              },
              model: {
                value: _vm.mailConfigData.from_name,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "from_name",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.from_name",
              },
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.from_name.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.from_name.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "base-button",
            {
              staticClass: "pull-right mt-4",
              attrs: {
                loading: _vm.loading,
                icon: "save",
                color: "theme",
                type: "submit",
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("general.save")) + "\n    ")]
          ),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }